import OrdersService from '../services/ordersService';
import { useMutation, useQuery } from '@tanstack/react-query';

export const useGetSingleOrder = (
	orderID: number,
	options?: { isEnabled: boolean },
) => {
	return useQuery<Order>({
		queryKey: ['order', orderID],
		queryFn: () =>
			OrdersService.getSingleResource(orderID, {
				getRelated: 'orderRows',
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetAllOrders = (options: { filters: string }) => {
	return useQuery<TavoittajaApiResponse<{ orders: Order[] }>>({
		queryKey: ['orders'],
		queryFn: () =>
			OrdersService.getAllResources({
				filters: options?.filters,
			}),
	});
};

export const useUpdateOrder = () => {
	return useMutation({
		mutationKey: ['orders'],
		mutationFn: (data: Partial<Order>) => OrdersService.update(data),
	});
};
